import React from 'react'

type SettingsColor = {
  color: string
}

export function SettingTwoIcon({ color }: SettingsColor) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.126 1.639a.75.75 0 01.868.382 2.25 2.25 0 004.012 0 .75.75 0 01.868-.382 10.733 10.733 0 014.444 2.487.75.75 0 01.162.88A2.25 2.25 0 0021.5 8.25h.031a.75.75 0 01.727.526 10.8 10.8 0 01.274 5.39.75.75 0 01-.808.596 2.25 2.25 0 00-1.944 3.689.75.75 0 01-.034 1.003 10.748 10.748 0 01-4.674 2.851.75.75 0 01-.928-.49 2.251 2.251 0 00-4.288 0 .75.75 0 01-.928.49 10.747 10.747 0 01-4.674-2.85.75.75 0 01-.033-1.004 2.25 2.25 0 00-1.944-3.689.75.75 0 01-.809-.596 10.795 10.795 0 01.274-5.39.75.75 0 01.727-.525H2.5a2.25 2.25 0 002.02-3.243.75.75 0 01.162-.881 10.734 10.734 0 014.444-2.487zm-3.043 3.25a3.75 3.75 0 01-3.048 4.822 9.27 9.27 0 00-.2 3.554 3.75 3.75 0 012.935 5.572 9.249 9.249 0 002.964 1.82A3.748 3.748 0 0112 18.75c1.402 0 2.623.769 3.266 1.907a9.25 9.25 0 002.964-1.82 3.75 3.75 0 012.934-5.572 9.332 9.332 0 00-.199-3.553 3.75 3.75 0 01-3.048-4.822 9.233 9.233 0 00-2.915-1.642A3.744 3.744 0 0112 4.75a3.744 3.744 0 01-3.002-1.502A9.234 9.234 0 006.083 4.89z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M7.75 12a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0zM12 9.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
        clipRule="evenodd"
      />
    </svg>
  )
}
